import { render, staticRenderFns } from "./PartnerGradeApprovalNew.vue?vue&type=template&id=2e075ca1&scoped=true"
import script from "./PartnerGradeApprovalNew.vue?vue&type=script&lang=js"
export * from "./PartnerGradeApprovalNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e075ca1",
  null
  
)

export default component.exports